import { render, staticRenderFns } from "./QuestionTwo.vue?vue&type=template&id=e48d70a6&"
import script from "./QuestionTwo.vue?vue&type=script&lang=js&"
export * from "./QuestionTwo.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTwo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VRow})
